export default __webpack_public_path__ + "static/media/wf.73e1b263.jpg";